<template>
  <div class="project-list main-content">
    <div class="soft-card table-soft-wrapper">
      <el-table
        :data="projectList"
        v-loading="loading"
        class="soft-el-table"
        header-row-class-name="soft-table-header"
        row-class-name="soft-table-row">
        <el-table-column
          prop="projectName"
          label="项目名称"
          min-width="200">
          <template slot-scope="scope">
            <div class="ellipsis-item" :title="scope.row.projectName">{{ scope.row.projectName }}</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="orderCount"
          label="订单总数"
          width="120">
        </el-table-column>
        <el-table-column
          prop="orderReportCount"
          label="报告数量"
          width="120">
        </el-table-column>
        <el-table-column
          prop="startTime"
          label="开始日期"
          width="160">
          <template slot-scope="scope">
            <div v-if="scope.row.startTime != 0 && scope.row.startTime != null">
              {{ scope.row.startTime | FormatDate('yyyy-MM-dd') }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="endTime"
          label="结束日期"
          width="160">
          <template slot-scope="scope">
            <div v-if="scope.row.endTime != 0 && scope.row.endTime != null">
              {{ scope.row.endTime | FormatDate('yyyy-MM-dd') }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="status"
          label="项目状态"
          width="120">
          <template slot="header" slot-scope="scope">
            <el-select
              popper-class="filter_options"
              v-model.number="status"
              size="mini"
              placeholder="订单状态"
              @change="searchProjects"
            >
              <el-option
                v-for="opt in status_options"
                :key="opt.value"
                :label="opt.name"
                :value="opt.value"
              />
            </el-select>
          </template>

          <template slot-scope="scope">
            <span :class="['status-pill', getStatusClass(scope.row.status)]">
              <i :class="getStatusIcon(scope.row.status)"></i>
              {{ getStatusText(scope.row.status) }}
            </span>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        :total="page_total"
        :current-page="current_page"
        :page-size="page_limit"
        :page-sizes="[10, 20, 50]"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange">
      </pagination>
    </div>
  </div>
</template>

<script>
import ApiService from "../service/ApiService";
import pub from "../service/public";
import Pagination from './Pagination.vue'

export default {
  name: "ProjectList",
  components: {
    Pagination
  },
  data() {
    return {
      loading: false,
      status_options: [],
      projectList: [],
      status: -1,
      page_total: 0,
      current_page: 1,
      page_sizes: [10, 20, 50, 100],
      page_limit: 10, // 每页多少条
    }
  },
  mounted() {
    this.initConstOptions();
    // 检查是否有从首页传递过来的状态参数
    if (this.$route.query.status) {
      this.status = Number(this.$route.query.status);
    } else {
      this.status = -1;
    }
    this.loadProjects();
  },
  methods: {
    // 初始化枚举选项
    initConstOptions() {
      let constData = pub.getConst();
      if (constData) {
        // 项目状态
        let orderState = [
          {
            name: '项目状态',
            value: -1
          }
        ]
        this.status_options = orderState.concat(constData.projectStatus);
      }
    },

    loadProjects() {
      if (this.loading) return;
      this.loading = true;
      const params = {
        page: {number: this.current_page - 1, limit: this.page_limit},
        keyWord: [],
        parms: {
          status: this.status
        }
      };

      ApiService.ManagerProjectList(params)
        .then(res => {
          if (res.code === pub.backCode.SUCCESS) {
            this.projectList = res.data.pageList || [];
            if (this.current_page == 1) {
              this.page_total = res.data.itemTotal || 0;
            }

          } else {
            pub.analysisReturnCode(res, null);
          }
        })
        .catch(error => {
          console.error('获取项目列表失败：', error);
          // pub.tip('获取项目列表失败', 'error');
        })
        .finally(() => {
          this.loading = false;
        });
    },
    searchProjects() {
      this.current_page = 1;
      this.status = Number(this.status);
      this.loadProjects();
    },

    handleSizeChange(size) {
      this.page_limit = size;
      this.current_page = 1;
      this.loadProjects();
    },

    handleCurrentChange(page) {
      this.current_page = page;
      this.loadProjects();
    },

    pageChange(item) {
      this.current_page = item.current_page;
      if (item.type == 'size') {
        this.page_limit = item.page_limit;
      }
      this.loadProjects(); //改变页码，重新渲染页面
    },
    getStatusClass(status) {
      const constData = pub.getConst();
      if (constData && constData.projectStatus) {
        const statusItem = constData.projectStatus.find(item => Number(item.value) === Number(status));
        if (statusItem) {
          if (statusItem.value === 300) {
            return 'pill-approved';
          }
          return statusItem.value === 400 ? 'pill-active' : 'pill-ended';
        }
      }
      // 默认映射
      const statusMap = {
        1: 'pill-active',
        2: 'pill-approved',
        3: 'pill-ended'
      };
      return statusMap[status] || 'pill-ended';
    },

    getStatusIcon(status) {
      const constData = pub.getConst();
      if (constData && constData.projectStatus) {
        const statusItem = constData.projectStatus.find(item => Number(item.value) === Number(status));
        if (statusItem) {
          if (statusItem.value === 300) {
            return 'fas fa-check-circle';
          }
          return statusItem.value === 400 ? 'fas fa-play-circle' : 'fas fa-stop-circle';
        }
      }
      // 默认映射
      const statusMap = {
        1: 'fas fa-play-circle',
        2: 'fas fa-check-circle',
        3: 'fas fa-stop-circle'
      };
      return statusMap[status] || 'fas fa-stop-circle';
    },
    getStatusText(status) {
      const constData = pub.getConst();
      if (constData && constData.projectStatus) {
        const statusItem = constData.projectStatus.find(item => Number(item.value) === Number(status));
        if (statusItem) {
          return statusItem.name || '未知';
        }
      }
      // 默认映射
      const statusMap = {
        1: '进行中',
        2: '已完成',
        3: '已暂停'
      };
      return statusMap[status] || '未知';
    },
  }
}
</script>

<style scoped lang="scss">
.project-list {
  .soft-el-table{
    min-height: 530px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ProjectList.vue